$.extend(FirstInNextMinutes.prototype, NextMinutes.prototype,
{
    buildInnerView (event, __html, _br, __me, lls)
    {
        var i = 0;

        __html += `
        <div class="event_wrapper">
            <div class="betType threeItems oddsButtons">
        `;
                for (i = 0; i < lls.length; i += 1)
                {
                    if (!lls[i]) { continue; }
                    this.drawLine(lls[i], __html, _br, __me, event);
                }
        __html += `
            </div>
        </div>
        `;
    }
});
